import { inject, Injectable, signal } from '@angular/core';
import { map, Observable, of, switchMap, tap } from 'rxjs';
import { differenceInMinutes } from 'date-fns';

import { VehicleService } from '@commons/services/vehicle/vehicle.service';
import { IGetTachographVehicleFileStatus, IGetVehicleTachographFileSchedule } from '@src/app/interfaces/api/files-ddd.interface';
import { FilesDddService } from '@src/app/services/api/files-ddd.service';
import { sortRoutesByDate as sortListByDate } from '@src/app/utils/date';

type VehicleFileStatus = Map<number, IGetTachographVehicleFileStatus>;

@Injectable({
  providedIn: 'root'
})
export class TachographFilesStatusService {
  private readonly vehicleService = inject(VehicleService);
  private readonly filesDDDService = inject(FilesDddService);

  public vehicleList = signal<IGetVehicleTachographFileSchedule[]>([]);
  public vehicleFileStatusList: VehicleFileStatus = new Map([]);

  private lastTimeDownload: Date = null!;

  constructor() { }

  public GetVehicleTachographFileSchedule(instantGet?: boolean): Observable<IGetVehicleTachographFileSchedule[]> {
    const minutesPassed = this.lastTimeDownload && differenceInMinutes(new Date(), this.lastTimeDownload);

    // Jezeli minuta mineła od ostatniego pobrania, lub gdy go jeszcze nie było
    if (!this.lastTimeDownload || minutesPassed || instantGet) {
      this.lastTimeDownload = new Date();
      return this.SetTachographVehicleFileStatus().pipe(
        switchMap(() => this.filesDDDService.GetVehicleTachographFileSchedule()),
        map(res => {
          return sortListByDate(
            res.Result.Schedules.map(
              item => ({
                ...item,
                Vehicle: this.vehicleService.getVehicleDetails(item.VehicleId),
                FilesStatus: this.vehicleFileStatusList.get(item.VehicleId)!,
              })
            ),
            'MandatedLoadDate',
          )
          .reverse();
        }),
        tap((data) => {
          console.log(data);
          this.vehicleList.set(data);
        }),
      );
    }

    return of(this.vehicleList());
  }

  private SetTachographVehicleFileStatus(): Observable<VehicleFileStatus> {
    return this.filesDDDService.GetTachographVehicleFileStatus().pipe(
      tap((res) => this.vehicleFileStatusList = new Map(res.map(item => [item.VehicleId, item]))),
      map(() => this.vehicleFileStatusList),
    );
  }

  public ForceVehicleFile(vehicleId: number): Observable<IGetVehicleTachographFileSchedule[]> {
    return this.filesDDDService.ForceFileDownloadForVehicle(vehicleId).pipe(
      switchMap(() => this.GetVehicleTachographFileSchedule(true)),
    );
  }

  public SetTachographScheduleForVehicles(vehiclesIds: number[], isAdd: boolean = true): Observable<void> {
    return this.filesDDDService.SetTachographScheduleForVehicles(vehiclesIds, isAdd);
  }

}
